export default __webpack_public_path__ + "static/boomwriter-img-be3cdbfdf0e16cbca9f5d51a83ed1e0a.png";